export default "__VITE_ASSET__B25oruEN__"